import {
  GET_USER_MANAGEMENT,
  GET_USER_MANAGEMENT_FAILURE,
  GET_USER_MANAGEMENT_SUCCESS,
  SHOW_USER_MANAGEMENT,
  SHOW_USER_MANAGEMENT_SUCCESS,
  SHOW_USER_MANAGEMENT_FAILURE,
  UPDATE_USER_MANAGEMENT,
  UPDATE_USER_MANAGEMENT_SUCCESS,
  UPDATE_USER_MANAGEMENT_FAILURE,
} from "../../Actions/types";

const initialState = {
  getLoader: false,
  getError: null,
  getData: null,
  showData: null,
  showLoader: false,
  showError: null,
  updateLoader: false,
  updateData: null,
  updateError: null,
};
function userManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER_MANAGEMENT:
      return { ...state, getLoader: true };
    case GET_USER_MANAGEMENT_SUCCESS:
      return { ...state, getData: action?.payload, getLoader: false };
    case GET_USER_MANAGEMENT_FAILURE:
      return { ...state, getError: true, getLoader: false };

    case SHOW_USER_MANAGEMENT:
      return { ...state, showLoader: true };
    case SHOW_USER_MANAGEMENT_SUCCESS:
      return { ...state, showData: action?.payload, showLoader: false };
    case SHOW_USER_MANAGEMENT_FAILURE:
      return { ...state, showError: true, showLoader: false };

    case UPDATE_USER_MANAGEMENT:
      return { ...state, updateLoader: true };
    case UPDATE_USER_MANAGEMENT_SUCCESS:
      return { ...state, updateData: action?.payload, updateLoader: false };
    case UPDATE_USER_MANAGEMENT_FAILURE:
      return { ...state, updateError: true, updateLoader: false };

    default:
      return state;
  }
}

export default userManagementReducer;
